import type { DeepPartial } from '../../default/types';
import type { OrderConfig } from '../../default/order/order.types';

export const orderConfig: DeepPartial<OrderConfig> = {
  paymentMethods: ['paypal', 'mastercard', 'visa', 'diners', 'discover'],
  externalUrls: {
    rsvDataProtection: {
      default: '/de/ratenschutz/datenschutz',
    },
    flexikontoPaymentPause: {
      default: '/service-hilfe/bezahlung-finanzierung/flexikonto-zahlpause',
    },
  },
  premium: {
    enabled: false,
    hasRuntimeOptions: false,
    hasLegalFooter: true,
    trackingDetail: 'Vorteilsclub',
  },
  flexikonto: {
    paymentProtectionAgeBreakpoint: 150,
  },
};
